export default __webpack_public_path__ + "static/media/icon-nodejs.4a6f1e90.svg";